import { render } from "./mark-feedback.vue?vue&type=template&id=01e39856&scoped=true"
import script from "./mark-feedback.vue?vue&type=script&lang=js"
export * from "./mark-feedback.vue?vue&type=script&lang=js"

import "./mark-feedback.vue?vue&type=style&index=0&id=01e39856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e39856"]])

export default __exports__